import React, {useState, useEffect} from 'react';
import './DetailsClub.css';
import ClubCalendrier from '../components/ClubCalendrier';
import { useLocation } from 'react-router-dom';
import { domain } from '../variables';
import axios from 'axios';
import LogoClub from '../components/LogoClub';
import PanelJoueur from '../components/PanelJoueur';
import JoueurInfo from '../components/JoueurInfo';

function DetailsClub({championnat, club}) {
    const state = useLocation();
    const [players, setPlayers] = useState([]);
    const [palmares, setPalmares] = useState([]);
    const [contacts, setContacts] = useState([]);

    let onglet = 1; 
    if (state !== undefined && state !== null) {
        if (state.state !== undefined && state.state !== null) {
            onglet = state.state.onglet;
        }
    }

    const [currentOnglet, setCurrentOnglet] = useState(onglet);

    useEffect(() => {
        switch (currentOnglet) {
            case 1:
                if (players.length < 1) {
                    // on récupère les joueurs
                    getPlayers();
                }
                break;
            case 3:
                if (palmares.length < 1) {
                    // on récupère les palmares
                    getPalmares();
                }
                break;
            case 4:
                if (contacts.length < 1) {
                    // on récupère les contacts
                    getContact();
                }
                break;
            default:
                break;
        }
    }, [currentOnglet])

    const getPlayers = async () => {
        const link = domain + '/server/getPlayersClub.php';
        await axios.post(
            link, 
            {
                championnat: championnat,
                club: club.id,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setPlayers(data);
            }
        })
    }

    const getPalmares = async () => {
        const link = domain + '/server/getPalmaresClub.php';
        await axios.post(
            link, 
            {
                championnat: championnat,
                club: club.id,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setPalmares(data);
            }
        })
    }

    const getContact = async () => {
        const link = domain + '/server/getContactClub.php';
        await axios.post(
            link, 
            {
                championnat: championnat,
                club: club.id,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setContacts(data);
            }
        })
    }

    return ( 
        <div className="details_club_page">

            {/* // BANNIERE */}
            <div className={"top_banniere " + championnat}>
                <div className="details_banniere_logo">
                    <LogoClub club={club} width='100%' height='100%' activateLink={false} />
                </div>
                <span className="top_banniere_title">
                    {club.title}
                </span>
            </div>

            <div className={"details_navbar "+championnat}>
                <span className={currentOnglet == 1 ? 'active' : ''} onClick={()=>setCurrentOnglet(1)}>Joueurs</span>
                <span className={currentOnglet == 2 ? 'active' : ''} onClick={()=>setCurrentOnglet(2)}>Calendrier/Resultats</span>
                {/* <span className={currentOnglet == 3 ? 'active' : ''} onClick={()=>setCurrentOnglet(3)}>Palmares</span> */}
                <span className={currentOnglet == 4 ? 'active' : ''} onClick={()=>setCurrentOnglet(4)}>Contacts</span>
            </div>

            <div className="details_club_content">
                

                {
                    (currentOnglet == 2 && <ClubCalendrier championnat={championnat} club={club}/>)
                    ||
                        currentOnglet == 1 &&
                        <div 
                            style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', gap: 25, padding: '50px 0px'}}
                        >
                            {
                                players.sort((a, b) => a.classement - b.classement).map((item, index) => {
                                    return (
                                        // <ClubJoueur key={index} championnat={championnat} player={item} />
                                        // <PanelJoueur key={index} championnat={championnat} player={item} />
                                        <JoueurInfo key={index} championnat={championnat} player={item} />
                                    )
                                })
                            }
                        </div>
                    ||
                    currentOnglet == 4 &&
                    <div className="details_club_info">
                        <h2>Contacts</h2>
                        {
                            contacts.length > 0 &&
                            contacts.map((item, index) => {
                                return (
                                    <div key={index} className="details_club_person">
                                        {item.photoContact !== "" && (
                                             <img 
                                                src={process.env.PUBLIC_URL + "/images/contacts/" + item.photoContact} 
                                                alt="" 
                                                width="125" 
                                                height="125"
                                                onError={({ currentTarget }) => {
                                                    currentTarget.onerror = null; 
                                                    currentTarget.src=process.env.PUBLIC_URL + "/images/no-photo.png";
                                                }}
                                            />
                                        )}
                                        <div style={{display: 'flex', flexDirection: 'column'}}>
                                            <h4>{item.roleContact}</h4>
                                            <span>{item.prenomContact + " " + item.nomContact.toUpperCase()}</span>
                                            <span>{item.emailContact}</span>
                                            <span>{item.telephoneContact}</span>
                                        </div>
                                    </div>
                                )
                            }) 
                            ||
                            <h1 style={{textAlign: 'center', color: 'rgb(50, 50, 50)'}}>Aucune information disponible</h1>
                        }
                        <h2>Salle</h2>
                        {
                            club.salle !== null &&
                            <div className="details_club_preview" style={{width: '100%'}}>
                                {club.photoSalle !== "" && (
                                    <img 
                                        src={process.env.PUBLIC_URL + "/images/salle/" + club.photoSalle} 
                                        alt="" 
                                    />
                                )}
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <h3>{club.salle || ""}</h3>
                                    <span>{club.adresse || " "}</span>
                                    <span>{(club.cp || "") + " " + (club.ville || "")}</span>
                                    {
                                        club.url !== "" &&
                                        <span><a style={{fontSize: 18}} href={club.url} target="_blank">Accéder au site officiel du club</a></span>
                                    }
                                </div>
                            </div>
                            ||
                            <h1 style={{textAlign: 'center', color: 'rgb(50, 50, 50)'}}>Aucune information disponible</h1>
                        }
                        
                    </div>
                    ||
                    currentOnglet == 3 &&
                    <div className="details_club_palmares">
                        {
                            palmares.map((item, index) => {
                                return (
                                    <div key={index} className="palmares">
                                        <img 
                                            src={process.env.PUBLIC_URL + "/images/" + item.logo} 
                                            alt="" 
                                            width="100" 
                                            height="100"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null; 
                                                currentTarget.src=process.env.PUBLIC_URL + "/images/no-pictures.png";
                                            }}
                                        />
                                        <div className="palmares_span_container" style={{display: 'flex', flexDirection: 'column'}}>
                                            <span style={{fontWeight: 'bold'}}>{item.title}</span>
                                            {
                                                <span style={{fontSize: 18}}>{item.subtitle}</span>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }

         
                    

            </div>
            
         
        </div>
    );
}

export default DetailsClub;